module.exports = __webpack_public_path__ + "static/img/tu11.590ec86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tu11.png
// module id = pSAV
// module chunks = 10